import { getChildren, getOmjsContainer, getOperationData } from 'selectors';
import { IState } from 'services/root-reducer';
import i18next from 'i18next';

interface ICategoriesConfig {
    containers: (string | number)[],
    legends: (string | number)[],
    objectsList: (string | number)[];
    private?: boolean
}

export const categoriesConfig: Record<string, ICategoriesConfig> = {
    select: {
        containers: [ 'plots', 'parks' ],
        legends: [ 'plots', 'parks' ],
        objectsList: [ 'plots', 'parks' ]
    },
    potential: {
        containers: [ 'info_layers_5', 'info_layers_6', 'programs', 'info_layers' ],
        legends: [ 'projects' ],
        objectsList: [ 'projects', 'ia138', 'folder42' ]
    },
    info: {
        containers: [ 'folder39', 'folder42', 'sez', 'port_zones', 'projects' ],
        legends: [ 'folder39', 'folder42', 'port_zones', 'sez' ],
        objectsList: [ 'folder39', 'port_zones', 'sez' ]
    },
    prospects: {
        containers: i18next.language === 'ru'
            ? [ 'stp', 'folder2', 'folder71', 'gen_plans' ]
            : [ 'stp', 'folder2' ],
        legends: [ 'programs' ],
        objectsList: i18next.language === 'ru'
            ? [ 'programs', 'gen_plans' ]
            : [ 'programs' ]
    }
};

if (i18next.language === 'ru') {
    categoriesConfig['folder5'] = {
        containers: [ 'folder88', 'folder12' ],
        legends: [ 'folder88', 'folder12' ],
        objectsList: [ 'folder88', 'folder12' ],
        private: true
    };
    categoriesConfig['folder6'] = {
        containers: [ 'ia33', 'communication', 'folder41', 'balance_territories' ],
        legends: [ 'folder41' ],
        objectsList: [ 'folder41' ],
        private: true
    };
}

export const isCategoryAvailable = (category: string) => {
    if (categoriesConfig[category]) {
        const allContainers: IState['operations']['CONTAINERS']['data'] = getOperationData(false, 'CONTAINERS');
        const categoryContainer = allContainers.find(cont => cont.code === category);
        if (categoriesConfig[category].private) {
            return categoryContainer
                && !!getChildren(false, categoryContainer.id, true).find(cont => cont.type !== 'folder');
        } else {
            return !!categoryContainer;
        }
    }
    return false;
};

export const isObjectListAvailable = (container: omjs.IContainer) => {
    let containers_with_objects_list = _.flatten(Object.values(categoriesConfig).map(conf => conf.objectsList));

    if (
        containers_with_objects_list.indexOf(container.code) !== -1
        || containers_with_objects_list.indexOf(container.id) !== -1
    ) {
        return true;
    }

    for (let i = 0; i < containers_with_objects_list.length; i++) {
        let container_code_with_objects_list = containers_with_objects_list[i];
        let container_with_objects_list = getOmjsContainer(false, container_code_with_objects_list);

        let container_children = getChildren(false, container_with_objects_list?.get('id'));
        let is_child = container_children.find(c => c.code === container.code);

        if (is_child) {
            return true;
        }
    }

    return false;
};

export const isLegendAvailable = (container: omjs.IContainer) => {
    let containers_with_legends = _.flatten(Object.values(categoriesConfig).map(conf => conf.legends));
    return (
        containers_with_legends.indexOf(container.code) !== -1
        || containers_with_legends.indexOf(container.id) !== -1
    );
};
